import React, { useState } from "react";
import {User, Session, Location} from "../types/Types";
import PageTracking from "../auth/PageTracking";
import {Navigate, useParams} from "react-router";
import {Card, Button} from "react-bootstrap";
import {Link} from "react-router-dom";
import AdminUpdates from "./components/AdminUpdates";
import AdminApplyOpeningDates from "./components/AdminApplyOpeningDates";
import AdminOpeningSoon from "./components/AdminOpeningSoon";
import AdminMissingOpeningDate from "./components/AdminMissingOpeningDate";
import AdminMissingClosingDate from "./components/AdminMissingClosingDate";
import AdminUserAnalytics from "./components/AdminUserAnalytics";
import AdminLocationTags from "./components/AdminLocationTags";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

interface Props {
    currentUser: User | undefined;
    usersMap: Map<string, User>;
    sessionsMap: Map<string, Session>;
    locations: Location[];
}

function AdminPage(props: Props) {
    const { tab } = useParams<{ tab: string }>();
    const [expandedCards, setExpandedCards] = useState<Record<string, boolean>>({});

    // Only allow access to admins
    if (!props.currentUser || !props.currentUser.admin) {
        return <Navigate to="/home" replace />;
    }

    if (tab === 'user-data') {
        return <Navigate to="/admin-page" replace />;
    }

    const toggleCard = (cardName: string) => {
        setExpandedCards(prev => ({
            ...prev,
            [cardName]: !prev[cardName]
        }));
    };

    const renderCardHeader = (cardName: string) => (
        <Card.Header>
            <div className="d-flex justify-content-between align-items-center">
                <b>{cardName}</b>
                <Button className="btn-sm" onClick={() => toggleCard(cardName)}>
                    <FontAwesomeIcon icon={expandedCards[cardName] ? faChevronUp : faChevronDown} />
                </Button>
            </div>
        </Card.Header>
    );

    return (
        <>
            <PageTracking />
            
            <Card className={"mb-3"}>
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center">
                        <div><b>Admin Dashboard</b></div>
                        <div>
                            <Link to="/admin">
                                <Button variant="primary" size="sm">Add Pub</Button>
                            </Link>
                        </div>
                    </div>
                </Card.Header>
            </Card>
            <Card className="mb-3">
                {renderCardHeader("Updates")}
            </Card>
            {expandedCards["Updates"] && (
                <AdminUpdates currentUser={props.currentUser} usersMap={props.usersMap} sessionsMap={props.sessionsMap} />
            )}

            <Card className="mb-3">
                {renderCardHeader("Pub Data")}
            </Card>
            {expandedCards["Pub Data"] && (
                <>
                    <AdminOpeningSoon locations={props.locations} />
                    <AdminMissingOpeningDate locations={props.locations} />
                    <AdminMissingClosingDate locations={props.locations} />
                    <AdminApplyOpeningDates locations={props.locations} />
                </>
            )}

            <Card className="mb-3">
                {renderCardHeader("User Data")}
            </Card>
            {expandedCards["User Data"] && (
                <AdminUserAnalytics />
            )}

            <Card className="mb-3">
                {renderCardHeader("Location Tags")}
            </Card>
            {expandedCards["Location Tags"] && (
                <AdminLocationTags />
            )}
        </>
    )
}

export default AdminPage;
